<div class="grid gap-4" [ngClass]="{ 'md:grid-cols-2': !stacked }">
    <div class="space-y-1">
        <label class="subheading">
            {{typeLabel}} <span *ngIf="required" class="text-red-600">*</span>
        </label>
        <select [ngModel]="selectedType" (ngModelChange)="onSelectType($event)">
            <option *ngFor="let type of types" [value]="type.value">{{type.label}}</option>
        </select>
    </div>

    <div *ngIf="!selectedTypeOption?.noRecords" class="space-y-1">
        <label class="subheading">
            {{selectedTypeOption?.recordLabel || selectedTypeOption?.label}} <span *ngIf="required" class="text-red-600">*</span>
        </label>
        <ng-select [items]="contacts" bindLabel="label" [ngModel]="selectedContact" (ngModelChange)="onSelectContact($event)"
            [typeahead]="searchSubject" [loading]="isLoading" [clearable]="true" [notFoundText]="'No record found'"
            [placeholder]="'Search ' + ((selectedTypeOption?.recordLabel || selectedTypeOption?.label) | lowercase)"
            [ngClass]="invalid ? 'border-main-danger' : 'border-gray-300'" class="w-full">
            <ng-template ng-option-tmp let-item="item">
                <div>{{item.label}}</div>
                <div *ngIf="item.detail" class="text-xs text-sm-light">{{item.detail}}</div>
            </ng-template>
        </ng-select>
    </div>
</div>
